/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockErrorGoodsProcessVo } from './StockErrorGoodsProcessVo';
import {
    StockErrorGoodsProcessVoFromJSON,
    StockErrorGoodsProcessVoFromJSONTyped,
    StockErrorGoodsProcessVoToJSON,
    StockErrorGoodsProcessVoToJSONTyped,
} from './StockErrorGoodsProcessVo';

/**
 * 
 * @export
 * @interface ProcessStockErrorGoodsReqVo
 */
export interface ProcessStockErrorGoodsReqVo {
    /**
     * 检查商品数据
     * @type {Array<StockErrorGoodsProcessVo>}
     * @memberof ProcessStockErrorGoodsReqVo
     */
    errorGoodsProcessVOs?: Array<StockErrorGoodsProcessVo>;
    /**
     * 订单ID
     * @type {number}
     * @memberof ProcessStockErrorGoodsReqVo
     */
    orderId?: number;
}

/**
 * Check if a given object implements the ProcessStockErrorGoodsReqVo interface.
 */
export function instanceOfProcessStockErrorGoodsReqVo(value: object): value is ProcessStockErrorGoodsReqVo {
    return true;
}

export function ProcessStockErrorGoodsReqVoFromJSON(json: any): ProcessStockErrorGoodsReqVo {
    return ProcessStockErrorGoodsReqVoFromJSONTyped(json, false);
}

export function ProcessStockErrorGoodsReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessStockErrorGoodsReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'errorGoodsProcessVOs': json['errorGoodsProcessVOs'] == null ? undefined : ((json['errorGoodsProcessVOs'] as Array<any>).map(StockErrorGoodsProcessVoFromJSON)),
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
    };
}

export function ProcessStockErrorGoodsReqVoToJSON(json: any): ProcessStockErrorGoodsReqVo {
    return ProcessStockErrorGoodsReqVoToJSONTyped(json, false);
}

export function ProcessStockErrorGoodsReqVoToJSONTyped(value?: ProcessStockErrorGoodsReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'errorGoodsProcessVOs': value['errorGoodsProcessVOs'] == null ? undefined : ((value['errorGoodsProcessVOs'] as Array<any>).map(StockErrorGoodsProcessVoToJSON)),
        'orderId': value['orderId'],
    };
}

